//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import GHeader from '@/common/components/g-header/'
  import userSignInfoMx from '../../mixins/userSignInfo.js'
  export default {
    components: { GHeader },
    mixins: [userSignInfoMx],
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data() {
      return {

      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/components/sign-head/index.vue